/*
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2025-11-22 16:05:01
 * @FilePath: \h5-front\src\router\home-page.js
 * @Description: 我的主页
 */

const realTimeData = () => import('@/views/pages/sensor-group/history/real-time-data.vue')
const sensorHistory = () => import('@/views/pages/sensor-group/history/sensor-history.vue')
const sensorAlarmSet = () => import('@/views/pages/sensor-group/alarm/sensor-alarm-set.vue')
const weatherAlarmSet = () => import('@/views/pages/sensor-group/alarm/weather-alarm-set.vue')
const setTimePeriod = () => import('@/views/pages/sensor-group/alarm/children/set-time-period.vue')
const deviceControl = () => import('@/views/pages/area-monitor/device-control/device-index.vue')
const deviceAutoSet = () => import('@/views/pages/area-monitor/device-control/alarm-config.vue')
const deviceMachineGroup = () => import('@/views/pages/area-monitor/device-control/machine-group.vue')
const deviceBatchOperate = () => import('@/views/pages/area-monitor/device-control/batch-operate.vue')
const deviceSetTimePeriod = () => import('@/views/pages/area-monitor/device-control/set-time-period.vue')

export default [
  {
    path: '/',
    redirect: '/home-page',
    meta: {}
  },
  {
    path: '/home-page',
    name: 'home',
    meta: {
      requiresAuth: true,
      layout: 'landing'
    },
    component: () => import('@/views/pages/home-page.vue')
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '@/views/errors/not-found-page.vue')
  },

   //   主页 - 传感器实时数据【从主页进入时，要传递传感器sn】
  {
    path: '/real-time-data',
    name: 'real-time-data',
    component: realTimeData,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },

  //   主页 - 传感器历史记录【从主页进入时，要传递传感器sn】
  {
    path: '/sensor-history',
    name: 'sensor-history',
    component: sensorHistory,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },

  //   主页 - 传感器报警配置【从主页进入时，要传递传感器id】
  {
    // path: '/sensor-alarm-set/:id',
    path: '/sensor-alarm-set',
    name: 'sensor-alarm-set',
    component: sensorAlarmSet,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  // 气象站报警配置
  {
    path: '/weather-alarm-set',
    name: 'weather-alarm-set',
    component: weatherAlarmSet,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  // 时间段设置
  {
    path: '/set-time-period',
    name: 'set-time-period',
    component: setTimePeriod,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },

  // 设备控制  从主页的区域中进入  【区域设备控制=> 风机、加热、卷膜】
  {
    path: '/device-control/device-index',
    name: 'area-device-control',
    component: deviceControl,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  // 区域监控下，从区域进入的设备控制，设备控制进入的【自动设置+报警配置】
  {
    path: '/device-control/auto-set',
    name: 'device-auto-set',
    component: deviceAutoSet,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  // 区域监控下，从区域进入的设备控制，设备控制进入的【设备分组】
  {
    path: '/device-control/machine-group',
    name: 'device-machine-group',
    component: deviceMachineGroup,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  // 区域监控下，从区域进入的设备控制，设备控制进入的【批量操作】
  {
    path: '/device-control/batch-operate',
    name: 'device-batch-operate',
    component: deviceBatchOperate,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  // 时间段设置
  {
    path: '/device-control/set-time-period',
    name: 'set-time-period',
    component: deviceSetTimePeriod,
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  }
]
